import { useQuery } from '@tanstack/react-query';
import type { PayoutTransaction } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const payoutsQueryKey = (runId: string) =>
  ['admin', 'settlement-payouts', runId] as const;

export const usePayoutsQuery = (runId: string | undefined) =>
  useQuery<ReadonlyArray<PayoutTransaction>>({
    queryKey: payoutsQueryKey(runId ?? ''),
    enabled: Boolean(runId),
    queryFn: async () => {
      const [data] = await apiClient.request(
        'get',
        '/admin/v1/settlements/{runId}/payouts',
        { params: { path: { runId: runId as string } } },
      );
      const payload = data as { items: PayoutTransaction[] };
      return payload.items;
    },
  });
